export default class UrlUtil{

    constructor(devServiceUrl,devClientUrl,prodClientDir){
      this.devServiceUrl = devServiceUrl;
      this.devClientUrl = devClientUrl;
      this.prodClientDir = prodClientDir;
    }
  
    getWindowMainUrl(){
      var curWwwPath=window.document.location.href;
      var pathName=window.document.location.pathname;
      var pos=curWwwPath.indexOf(pathName);
      var localhostPath=curWwwPath.substring(0,pos);
      return localhostPath;
    }
  
    getGatewayUrl(){
      if(process.env.NODE_ENV!='development'){
        return this.getWindowMainUrl();
      }else{
        return this.devServiceUrl;
      }
    }
    
    getClientUrl(){
      if(process.env.NODE_ENV!='development'){
            if((!this.prodClientDir)||(this.prodClientDir==''))
                return this.getWindowMainUrl();
            return this.getWindowMainUrl()+'/'+this.prodClientDir;
      }else{
        return this.devClientUrl;
      }
    }
  
  
  }
  